import React from 'react'
import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useStyles } from "./styles";

function FAQComponent() {
  const [expanded, setExpanded] = React.useState('panel1');
  const classes = useStyles();

  return (
    <Grid container item xs={12} className={classes.FAQWrapper}>
        <div id='faq' className={classes.faqHook}></div>
        <Typography component="h1" variant="h5" color="inherit" gutterBottom className={classes.FAQHeader}>
            Frequently Asked Questions
        </Typography>
        <Grid xs={10} item>
          <Accordion
            expanded={expanded === 'panel1'}
            onChange={() => setExpanded('panel1')} 
            className={classes.accordianSection}>
              <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
              >
                  <Typography>How do I login?</Typography>
              </AccordionSummary>
              <AccordionDetails>
              <Typography variant="body2" color="inherit" style={{ color: "black", fontSize: "14px" }}>
                Login to your account using the username/password provided during your last Ultrasound scan.
              </Typography>
              </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === 'panel2'} onChange={() => setExpanded('panel2')} 
            className={classes.accordianSection}>
              <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
              >
              <Typography>How long are my images available for?</Typography>
              </AccordionSummary>
              <AccordionDetails>
              <Typography  variant="body2" color="inherit" style={{ color: "black", fontSize: "14px" }} paragraph>
              Your most recent visit’s images will be available online for 2 weeks from the date of your exam. After that time, 
              images will be deleted from our servers. In the event you have multiple visits during that time period, all submitted 
              images will be available for your viewing.
              </Typography>
              </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === 'panel3'} onChange={() => setExpanded('panel3')} 
            className={classes.accordianSection}>
              <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
              >
              <Typography>Are my images protected?</Typography>
              </AccordionSummary>
              <AccordionDetails>
              <Typography  variant="body2" color="inherit" style={{ color: "black", fontSize: "14px" }} paragraph>
              Yes. We take your privacy and security very seriously. Any identifying information on the original Ultrasound image has been 
              removed for your safety. You can freely share these images without concern.
              </Typography>
              </AccordionDetails>
          </Accordion>
        </Grid>
    </Grid>
  );
}

export default FAQComponent
